import { Component, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { merge, fromEvent, combineLatest, tap, filter, takeUntil} from 'rxjs';
import { throttleTime, map, distinctUntilChanged } from 'rxjs';
import { UrlBuilderService } from '../../common/services/url-builder.service';
import { OidcAuthService } from '../../auth/services/oidc-auth.service';
import { OnDestroySubject } from '@common/components/on-destroy-subject';
import { HttpClient } from '@angular/common/http';

@Component({
    selector: 'mojo-activity-recorder',
    templateUrl: './activity-recorder.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})

export class ActivityRecorderComponent
  extends OnDestroySubject
  implements OnInit {

  constructor(
    private readonly oidcAuthService: OidcAuthService,
    private readonly urlBuilder: UrlBuilderService,
    private readonly http: HttpClient) {
    super();
  }

  ngOnInit() {

    const incr = () => {
      let num = 0;
      return () => num = num + 1;
    };
    const cacheId = incr();
    const getRecordActivityUrl = (v) => this.urlBuilder.getRecordActivityUrl() + '?nocache=' + v;
    const getThrottleTime = () => 5000;
    const makeUrl = () => getRecordActivityUrl(cacheId());


    /*
     * As an iframe is currently being used to call the id server api this code has been implemented in a component
     * Should we change to call the api directly we can move this to a service
     */

    const clicks = fromEvent(window, 'click');
    const keys = fromEvent(window, 'keypress');
    const mousemoves = fromEvent(window, 'mousemove');
    const isLoggedIn$ = this.oidcAuthService.userIsLoggedIn().pipe(distinctUntilChanged());

    combineLatest([isLoggedIn$, merge(clicks, keys, mousemoves)]).pipe(
      takeUntil(this.destroy$),
      throttleTime(getThrottleTime()),
      map(makeUrl),
      tap(url => this.http.get(url).subscribe()) // see GlobalErrorHandler
    ).subscribe();
  }
}

